define("authui/login2/controllers/login2Controller", [
        "language/resource",
        "base/utils/cookie",
        "authui/iamUtils",
        "authui/login2/controllers/baseLoginController",
        "base/utils/iamHttpService",
        "qrcode"
    ], function(i18n, cookieOp, iamUtils, LoginController,iamHttpService, QRCode){
    "use strict";

    var me;
    var QRCODE_VALID_TIME = 120; //二维码失效时间，单位秒
    var ACL_DENY_CODE = '416';
    function CustomerLoginController ($scope, $timeout, securityPolicy, $state, $sce, $interval){

        $scope.$sce = $sce;
        // 判断是否已经有登录 
        $.ajax({
            "type": "GET",
            "contentType": "application/x-www-form-urlencoded; charset=UTF-8",
            "url": "/authui/isLogin",
            "async": true,
            "success": function(data) {
                data = typeof data === "object" ? data : $.parseJSON(data);
                if (data.result === "islogin" && data.code === 201 && data.status === "success") {
                    // 说明已经有会话登录 重定向一次
                    window.location.href = "/authui/" + window.location.search;
                }
            },
            "error": function() {
                $scope.model.serverError = i18n("systemException");
                setTimeout(function(){
                    $scope.model.serverError = "";
                }, 10000);
            }
        });

        // 样式文件加载
        var cssFileArr = {
            "zh-cn": "/authui/public/custom/css/zh-cn/loginpage.css",
            "en-us": "/authui/public/custom/css/en-us/loginpage.css",
            "es-us": "/authui/public/custom/css/es-us/loginpage.css",
            "pt-br": "/authui/public/custom/css/pt-br/loginpage.css"
        }
        $scope.cssFile = cssFileArr[window.language];

        var blueImg = "/authui/public/custom/images/blue_triangle.png";
        var grayImg = "/authui/public/custom/images/gray_triangle.png";
        me = this;
        try{
            iamUtils.initialCloudBI("/authui/#/login",{C1:"IAM-Login"});
        }catch(e){
            console.dir(e)
        }
        
        LoginController.call(this, $scope, $timeout, securityPolicy, i18n, iamUtils, $state);

        if (!window.LOGIN_CONFIG.switch_zhengwuyunzhuanqu) {
            createAdvScript();
        }

        if (getQueryString("UserType")) {
            // 是否指定了IAM用户登录
            $scope.model.isCompany = getQueryString("UserType") === "e" ? true : false;
        }

        $scope.model.homepageUrl = $scope.ipIsInternational? iamUtils.CONFIG.HongKongHomepageUrl:iamUtils.CONFIG.homepageUrl;
        $scope.model.currentLanguage = window.language;
        $scope.model.fromQuickLogin = getQueryString("quickLogin") === "true";//标记来源是否是快捷登录
        $scope.model.quickLoginUrl = getQuickLoginUrl();
        // RR2020021101004
        $scope.model.WeLinkUrl = getWeLinkUrl();
        $scope.model.isIdpLogin = false;

        $scope.model.registUrl = getRegistUrl($scope);
        $scope.model.vmallUrl = getVmallUrl();
        $scope.model.hwportalUrl = getHwPortalUrl();
        $scope.model.eChannelUrl = getEchannelUrl();
        $scope.model.uniportalUrl = getUniportalUrl();
        $scope.model.openEchannel = true;
        $scope.model.isIAMUserLogin = cookieOp.getCookie("accountType") === "company" ? false : true;
        $scope.model.hwdeveloperUrl = getHwDeveloperUrl();
        $scope.model.areaCodeDisabled = true;
        $scope.model.matchMethod = 'any-nocap';
        $scope.model.inputFieldHeight = "36px";
        $scope.model.codeInputWidth = "220px";
        $scope.model.phoneInputWidth = "205px";
        $scope.model.moreLinkIsShow = false;
        $scope.model.listImg = grayImg;
        $scope.model.width = 320;
        $scope.model.height = 36;
        $scope.model.isUsePhone = true;
        $scope.model.listStyle = "display:none";
        $scope.model.registTip = {
    	    "content": i18n("loginRegistTip"),
    	    "position": "top",
    	    "auto": "true"
    	};

        $scope.model.uniportalTip = {
        	    "content": i18n("uniportalTip"),
        	    "position": "right",
        	    "auto": "true"
		};
        
    	$scope.model.accountNamePH= i18n("accountPlaceHolder");
    	$scope.model.personageUser = i18n("hwId.hwCloudAccountLogin");
    	$scope.model.enterpriseUser = i18n("enterpriseUser");
    	$scope.model.chkTxt = i18n("rememberName");
        $scope.cbcRiskcheckAddress = 'https://res.hc-cdn.com/riskcontrol-accountguard/2.0.7/riskIntegrated/cn/accountguard.js?t=' + new Date().getTime();
        loadRiskJs($scope.cbcRiskcheckAddress);
    	$scope.model.errorMsgObj = {
                        "401": $scope.ipIsInternational && i18n("wrongNamePwd4Intl")?i18n("wrongNamePwd4Intl"):i18n("wrongNamePwd"),
                        "402": $scope.ipIsInternational && i18n("wrongNamePwdoneChances4Intl")? i18n("wrongNamePwdoneChances4Intl"):i18n("wrongNamePwdoneChances"),
                        "403": $scope.ipIsInternational && i18n("wrongNamePwdTwoChances4Intl")? i18n("wrongNamePwdTwoChances4Intl"):i18n("wrongNamePwdTwoChances"),
                        "404": $scope.ipIsInternational && i18n("wrongNamePwdThreeChances4Intl")? i18n("wrongNamePwdThreeChances4Intl"):i18n("wrongNamePwdThreeChances"),
                        "405": i18n("wrongNamePwdFourChances"),
                        "406": i18n("invalidInput"),
                        "407": i18n("invalidInputoneChances"),
                        "408": i18n("invalidInputTwoChances"),
                        "409": i18n("invalidInputThreeChances"),
                        "410": i18n("invalidInputFourChances"),
                        "411": i18n("wrongVerifyCode"),
                        "412": i18n("loginReactivateFail"),
                        "413": i18n("userAccountsLocked"),
                        "414": i18n("domainuserAccountsLocked"),
                        "415": i18n("userAccountsLocked"),
                        "417": i18n("systemException"),
                        "418": i18n("verifyCode.error"),
                        "419": i18n("verifyCode.invalid"),
                        "420": i18n("userAccountsStopped"),
                        "423": i18n("serviceUrlInvalid"),
                        "424": i18n("maxSessionLimit"),
                        "427": i18n("multiUserInvalid"),
                        "428": i18n("accountClosed"),
                        "430": i18n("hasBindUniportal"),
                        "432": i18n("pageTimeout"),
                        "439": i18n("usbKey.error.noPwdLogin"),
                        "508121000": i18n("wrongIPBlacklist"),
                        "508121001": i18n("wrongIPFrequencyLimiting"),
                        "508121002": i18n("wrongEquipmentIDFrequencyLimiting"),
                        "508121003": i18n("MachineOperation"),
                        "IAM.0012": i18n("operationTooFrequent"),
                        "IAM.0004": i18n("pageTimeout"),
                        "IAM.1063": i18n("wrongVerifyCode"),
                        "IAM.1065": i18n("domainAccountsStopped"),
                        "IAM.1066": i18n("quickLogin.notActivate"),
                        "IAM.0018": i18n("invalidInput"),
                        "IAM.0007": i18n("invalidInput"),
                        "noIdps": i18n("idpLogin.noIdps"),
                        "operationTooFrequent": i18n("operationTooFrequent"),
                        "domainNotExist": i18n("idpLogin.domainNotExist"),
                        "idpIpLock": i18n("mobileLoginModel.operationTooFrequent"),
        };

        $(document).keydown(function (event) {
            if(event.keyCode === 13){
                var id = $(document.activeElement).attr("id");
                if(($scope.model.isNeedVerifyCode && id === "checkCodeId")|| id === "userNameId" || id === "pwdId" || id === "accountNameId" || id === "loginBtn"){
                    $scope.loginClick();
                    $scope.$apply();
                }
            }
        });

        $("#goLogin").click(function(){
            if($scope.goLoginType=="HWS")
            {
                window.location.href = window.replaceDomain("https://"+'auth.huaweicloud.com'+"/authui/?locale=" + window.language);
            }
            else if($scope.goLoginType=="HK")
            {
                window.location.href = window.replaceDomain("https://"+'auth-intl.huaweicloud.com'+"/authui/?locale=" + window.language);
            }
            else if($scope.goLoginType=="ACL")
            {
                window.location.href = iamUtils.CONFIG.helpCenterUrl +  i18n('clientIpInvalid.helpUrl');
            }
            else {
                window.location.href = window.replaceDomain("https://"+'auth-intl.huaweicloud.com'+"/authui/?locale=" + window.language);
            }
        });

        /*** 手机号登录需求相关代码均在下方直到 END ***/

        function send2CloudBISafe(){
            try{
                send2CloudBI.apply(null,arguments);

            }catch(e){
                console.dir(e)
            }
        }

        //悬浮在IAM帐号用户名输入框时，显示tip
        $scope.bindIAMAccountTip = function() {
            var tip = i18n('iamAccountTip');
            if (iamUtils.CONFIG.helpCenterUrl) {
                var url = iamUtils.CONFIG.helpCenterUrl + i18n('iamAccountTipHelp');
                tip +=
                    iamUtils.i18nFormat("<a href='{0}' target='_blank'>{1}</a>", url, i18n('learnMore'));
            }
            $timeout(
                function() {
                    iamUtils.showTooltip($('#IAMAccountInputId'), tip);
                }
            );
        }

        $scope.bindIAMUsernameTip = function() {
            var tip = i18n('iamUsernameTip');
            if (iamUtils.CONFIG.helpCenterUrl) {
                var url = iamUtils.CONFIG.helpCenterUrl + i18n('iamUsernameTipHelp');
                tip +=
                    iamUtils.i18nFormat("<a href='{0}' target='_blank'>{1}</a>", url, i18n('learnMore'));
            }
            $timeout(
                function() {
                    iamUtils.showTooltip($('#IAMUsernameInputId'), tip);
                }
            );
        }

        $scope.goFindPwd = function(send, event, button, click, login_fpwd) {
            var fpwdURI = getFpwdUrl();
            $scope.BiEvent(send, event, button, click, login_fpwd, fpwdURI);
            window.location.href = fpwdURI;
        }

        // 个人帐号登录方式下 帐号名邮箱输入框
        $scope.personalAccountInput = {
            id: "personalAccountInputId",
            value: "",
            oldValue: "",
            focused: false,
            ph: i18n("mobileLoginModel.accountPlaceHolder"),
            change: function() {
                // 内容修改则清空密码
                $scope.personalPasswordInput.value = "";
                // 清空邮箱多用户选择框
                $scope.emailLoginModel.showEmailSelect = false;
                $scope.personalAccountInput.oldValue = "";
            },
            blur: function() {
                send2CloudBISafe("input", "change" , "login_personal_userName", $scope.personalAccountInput.value);
                if($scope.model.fromQuickLogin && $scope.model.serverError == i18n("quickLogin.qucikLoginTip")){
                    $scope.model.serverError = "";
                } 
                $scope.personalAccountInput.value = $scope.personalAccountInput.value.trim();
                // 判断是否是邮箱登录            
                var emailPattern = iamUtils.EmailRegex;
                if (emailPattern.test($scope.personalAccountInput.value)) {
                    $("#serverError").hide();
                    $("#checkError").hide();
                    // 若为邮箱，多用户处理            
                    $scope.emailLoginModel.emailExist();
                } else {
                    // 原逻辑            
                    // 增加对输入帐号名是否为手机号的提示 仅在国内IP时使用            
                    if (!$scope.ipIsInternational) {
                        var phonePatternRegex = /^1\d{10}$/;
                        if (phonePatternRegex.test($scope.personalAccountInput.value)) {
                            $("#isMobileTip").show();
                            $scope.mobileLoginModel.isMobilePattern = true;
                        } else {
                            $("#isMobileTip").hide();
                            $scope.mobileLoginModel.isMobilePattern = false;
                        }
                    }
                    if (!$scope.personalAccountInput.value || $scope.personalAccountInput.value === $scope.personalAccountInput.oldValue) {
                        return;
                    }
                    $("#serverError").hide();
                    $("#checkError").hide();
                    $scope.personalAccountInput.oldValue = $scope.personalAccountInput.value;
                    me.loginCheck($scope);
                }
            },
            focus: function() {
                if($scope.model.fromQuickLogin && !$scope.model.serverError){
                    $scope.model.serverError = i18n("quickLogin.qucikLoginTip");
                }  
            },
            getFocus: function() {
                setTimeout(function(){
                    $("#" + $scope.personalAccountInput.id + ">input")[0].focus();
                },100)
            }
        }
        // 个人帐号登录方式下 密码输入框
        $scope.personalPasswordInput = {
            type: "password",
            id: "personalPasswordInputId",
            value: "",
            ph: i18n("passwdPlaceHolder"),
            pwdVisible: false,
            pwdVisibleFunc: function() {
                $scope.personalPasswordInput.pwdVisible = !$scope.personalPasswordInput.pwdVisible;
                var type = $scope.personalPasswordInput.pwdVisible ? "text" : "password";
                $("#" + $scope.personalPasswordInput.id + ">input").attr("type", type);
            },
            getFocus: function() {
                setTimeout(function(){
                    $scope.personalAccountInput.blur();
                    $("#" + $scope.personalPasswordInput.id + ">input")[0].focus();
                },100)
            }
        }

        // 手机号登录方式下 手机号输入框
        $scope.mobileInput = {
            type: "text",
            id: "mobileInputId",
            value: "",
            oldValue: "",
            focused: false,
            ph: i18n("mobileLoginModel.mobilePlaceHolder"),
            getFocus: function() {
                setTimeout(function(){
                    $("#" + $scope.mobileInput.id + ">input")[0].focus();
                },100)
            }
        }
        // 手机号登录方式下 密码输入框
        $scope.mobilePasswordInput = {
            type: "password",
            id: "mobilePasswordInputId",
            value: "",
            ph: i18n("passwdPlaceHolder"),
            pwdVisible: false,
            pwdVisibleFunc: function() {
                $scope.mobilePasswordInput.pwdVisible = !$scope.mobilePasswordInput.pwdVisible;
                var type = $scope.mobilePasswordInput.pwdVisible ? "text" : "password";
                $("#" + $scope.mobilePasswordInput.id + ">input").attr("type", type);
            },
            getFocus: function() {
                setTimeout(function(){
                    $("#" + $scope.mobilePasswordInput.id + ">input")[0].focus();
                },100)
            }
        }

        // IAM用户登录方式下 帐号名输入框
        $scope.IAMAccountInput = {
            id: "IAMAccountInputId",
            value: "",
            oldValue: "",
            focused: false,
            ph: i18n("accountPlaceHolder"),
            disable: false,
            change: function() {
                // 内容修改则清空密码
                $scope.IAMPasswordInput.value = "";
            },
            blur: function() {
                send2CloudBISafe("input", "change" , "login_company_accountName", $scope.IAMAccountInput.value.trim());
                if(!$scope.IAMAccountInput.value || $scope.IAMAccountInput.value === $scope.model.lastAccountName) {
                    return;
                }
                $scope.IAMAccountInput.value = $scope.IAMAccountInput.value.trim();
                $scope.model.serverError = "";
                $scope.model.goLogin = "";
                $scope.model.goLogin1 = "";
                $("#checkError").hide();
                $scope.model.lastAccountName = $scope.IAMAccountInput.value;
                me.loginCheck($scope);
            },
            getFocus: function() {
                setTimeout(function(){
                    $("#" + $scope.IAMAccountInput.id + ">input")[0].focus();
                },100)
            }
        }
        // IAM用户登录方式下 用户名输入框
        $scope.IAMUsernameInput = {
            type: "text",
            id: "IAMUsernameInputId",
            value: "",
            oldValue: "",
            focused: false,
            ph: i18n("userNamePlaceHolder"),
            phIntl: i18n("HongKongUserNamePlaceHolder"),
            disable: false,
            change: function() {
                // 内容修改则清空密码
                $scope.IAMPasswordInput.value = "";
            },
            blur: function() {
                send2CloudBISafe("input", "change" , "login_company_userName", $scope.IAMUsernameInput.value.trim());
                if(!$scope.IAMUsernameInput.value || $scope.IAMUsernameInput.value === $scope.IAMUsernameInput.oldValue) {
                    return;
                }
                $scope.IAMUsernameInput.value = $scope.IAMUsernameInput.value.trim();
                $scope.model.serverError = "";
                $scope.model.goLogin = "";
                $scope.model.goLogin1 = "";
                $("#checkError").hide();
                $scope.IAMUsernameInput.oldValue = $scope.IAMUsernameInput.value;
                me.loginCheck($scope);
            },
            getFocus: function() {
                setTimeout(function(){
                    $scope.IAMAccountInput.blur();
                    $("#" + $scope.IAMUsernameInput.id + ">input")[0].focus();
                },100)
            }
        }
        // IAM用户登录方式下 密码输入框
        $scope.IAMPasswordInput = {
            type: "password",
            id: "IAMPasswordInputId",
            value: "",
            focused: false,
            ph: i18n("iamPasswdPlaceHolder"),
            pwdVisible: false,
            pwdVisibleFunc: function() {
                $scope.IAMPasswordInput.pwdVisible = !$scope.IAMPasswordInput.pwdVisible;
                var type = $scope.IAMPasswordInput.pwdVisible ? "text" : "password";
                $("#" + $scope.IAMPasswordInput.id + ">input").attr("type", type);
            },
            getFocus: function() {
                setTimeout(function(){
                    $scope.IAMAccountInput.blur();
                    $("#" + $scope.IAMPasswordInput.id + ">input")[0].focus();
                },100)
            }
        }
        // 手机号登录切换功能相关变量 防止变量名冲突
        $scope.mobileLoginModel = {
            intlIpTip: i18n("mobileLoginModel.intlIpTip"),
            switchTypeLabel: i18n("mobileLoginModel.mobileLogin"),
            mobileCheckLoading: false,
            showMobileErrorMsg: false,
            showMobileSelect: false,
            countryCode: "",
            selectedUser: {},
            loginUserId: "",
            loginUserDomainId: "",
            registUrl: "",
            isMobilePattern: false,
            isMobileTip: i18n("mobileLoginModel.isMobileTip"),
            notRegisterTip: i18n("mobileLoginModel.notRegisterTip"),
            registerNow: i18n("mobileLoginModel.registerNow"),
            multiUsersTip: i18n("mobileLoginModel.multiUsersTip"),
            mobileValidator: [{
                "validFn": "required"
            }, {
                "validFn": "regularCheck",
                "params": "/^1\\d{10}$/",
                "errorDetail": i18n("mobileLoginModel.invalidNumber")
            }],
            initSwitchType: function() {
                // 初始化手机号登录切换按钮
                $scope.mobileInput.oldValue = "";
                $scope.model.mobileLogin = false;
                $scope.mobileLoginModel.switchTypeLabel = i18n("mobileLoginModel.mobileLogin");
                $scope.model.mobileLogin = false;
                $scope.model.userNamePH = $scope.model.isCompany ? i18n("mobileLoginModel.userPlaceHolder") : i18n("mobileLoginModel.accountPlaceHolder");
                $scope.mobileLoginModel.showMobileErrorMsg = false;
                $scope.mobileLoginModel.showMobileSelect = false;
            },
            switchTypeClick: function(event) {
                $("#isMobileTip").hide();
                $("#checkError").hide();
                $("#serverError").hide();
                if (event.which !== 1) {
                    // 不是左键触发
                    return false;
                }
                // 切换手机号登录
                $scope.model.isNeedVerifyCode = false;
                $scope.model.lastUserName = "";
                $scope.mobileInput.oldValue = "";
                // 如果在主界面输入了手机格式 点击切换过来之后 不清空填写的手机号 并且触发手机号校验
                if ($scope.mobileLoginModel.isMobilePattern) {
                    $scope.mobileLoginModel.isMobilePattern = false;
                    $scope.mobileInput.value = $scope.personalAccountInput.value;
                    $scope.personalAccountInput.value = "";
                    $scope.mobileBlur();
                } else {
                    $scope.mobileInput.value = "";
                }
                $scope.model.userName = "";
                $scope.personalPasswordInput.value = "";
                $scope.personalPasswordInput.pwdVisible = false;
                $scope.mobilePasswordInput.value = "";
                $scope.mobilePasswordInput.pwdVisible = false;
                $scope.model.mobileLogin = !$scope.model.mobileLogin;
                if ($scope.model.mobileLogin) {
                    // 使用手机号登录
                    $scope.mobileInput.getFocus();
                    $scope.model.areaCodeDisabled = true;
                    $scope.mobileLoginModel.switchTypeLabel = i18n("mobileLoginModel.accountLogin");
                    $scope.model.mobileLogin = true;
                    $scope.personalAccountInput.value = "";
                    $scope.personalAccountInput.oldValue = "";
                    $scope.emailLoginModel.showEmailSelect = false;
                } else {
                    $scope.personalAccountInput.getFocus();
                    $scope.mobileLoginModel.showMobileErrorMsg = false;
                    $scope.mobileLoginModel.showMobileSelect = false;
                    $scope.mobileLoginModel.switchTypeLabel = i18n("mobileLoginModel.mobileLogin");
                    $scope.model.mobileLogin = false;
                    $scope.model.userNamePH = i18n("mobileLoginModel.accountPlaceHolder");
                }
            },
            mobileExist: function() {
                // 查询手机是否注册
                if ($scope.mobileInput.value == "" || $scope.mobileInput.oldValue == $scope.mobileInput.value) {
                    return;
                }
                $scope.mobileLoginModel.mobileCheckLoading = true;
                iamHttpService.post({
                    url: "/authui/findowner",
                    params: {
                        type: "mobile",
                        value: $scope.mobileInput.value
                    }
                }).then(function (data) {
                    // 记录旧值 防止多次请求
                    $scope.mobileInput.oldValue = $scope.mobileInput.value;

                    var data = typeof data === 'object' ? data : $.parseJSON(data);
                    $scope.mobileLoginModel.mobileCheckLoading = false;
                    $scope.mobileInput.focused = false;
                    if (data.result === "success") {
                        var count = data.count;
                        if (count > 0) {
                            // 已经注册 区分单个帐号多个帐号的显示逻辑
                            $scope.mobileLoginModel.showMobileErrorMsg = false;
                            $scope.model.pwd = "";
                            // 处理数据格式用以适配控件
                            for (var i = 0; i < data.users.length; i++) {
                                data.users[i].selectId = i + 1;
                                data.users[i].label = data.users[i].name;
                                if (i==0) {
                                    $scope.mobileLoginModel.loginUserId = data.users[i].id;
                                    $scope.mobileLoginModel.loginUserDomainId = data.users[i].domain_id;
                                }
                            }

                            if (count > 1) {
                                // 多帐号
                                $scope.mobileLoginModel.showMobileSelect = true;
                                $scope.mobileUsers.selectOptions = data.users;
                                $scope.$apply();
                                // 重新渲染之后得到控件 设置默认值
                                $("#mobileUsers").widget().opChecked("1");
                            } else {
                                // 单帐号
                                $scope.$apply();
                            }
                            
                            // 查询是否需要验证码
                            $scope.mobileLoginVerify();
                        } else {
                            // 未注册
                            $scope.mobileLoginModel.showMobileErrorMsg = true;
                            $("#checkErrorInfo").hide();
                            // 拼接注册链接
                            var countryCode = $("#codeSelectId").length > 0 ?  iamUtils.getCodeValue($scope.model.codeJson, $("#codeSelectId").widget().getValue()): iamUtils.getCodeValue($scope.model.codeJson, $scope.model.defaultValue);
                            $scope.mobileLoginModel.registUrl = "https://reg.huaweicloud.com" + "/registerui/register.html?locale=zh-cn&locateType=mobile&areacode=" + countryCode +"&locateId=" + $scope.mobileInput.value;
                            $scope.mobileLoginModel.registUrl = window.replaceDomain($scope.mobileLoginModel.registUrl);
                            $scope.$apply();
                        }
                    } else {
                        // 请求返回错误
                        if (data.message === "addrFrequencyHitMax") {
                            $scope.model.serverError = iamUtils.i18nFormat(i18n("mobileLoginModel.operationTooFrequent"), 5);
                            $scope.model.pwd = "";
                            $("#checkError").hide();
                            $("#serverError").show();
                            $scope.$apply();
                        }
                    }
                }, function() {
                    $scope.mobileLoginModel.mobileCheckLoading = false;
                    $scope.model.serverError = $scope.model.errorMsgObj["417"];
                    $("#checkError").hide();
                    $("#serverError").show();
                    $scope.$apply();
                });
            }
        };

        // 邮箱登录相关model            
        $scope.emailLoginModel = {
            loginUserId: "",
            loginUserDomainId: "",
            emailCheckLoading: "",
            showEmailSelect: false,
            emailExist: function () {
                // 查询邮箱            
                if ($scope.personalAccountInput.value == "" || $scope.personalAccountInput.oldValue == $scope.personalAccountInput.value) {
                    return;
                }
                $scope.emailLoginModel.emailCheckLoading = true;
                iamHttpService.post({
                    url: "/authui/findowner",
                    params: {
                        type: "email",
                        value: $scope.personalAccountInput.value
                    }
                }).then(function (data) {
                    // 记录旧值 防止多次请求            
                    $scope.personalAccountInput.oldValue = $scope.personalAccountInput.value;

                    var data = typeof data === 'object' ? data : $.parseJSON(data);
                    $scope.emailLoginModel.emailCheckLoading = false;           
                    if (data.result === "success") {
                        var boundAccountCount = data.count;
                        if (boundAccountCount > 0) {
                            // 已经注册 区分单个帐号多个帐号的显示逻辑            
                            $scope.emailLoginModel.showEmailErrorMsg = false;
                            $scope.model.pwd = "";
                            // 处理数据格式用以适配控件            
                            for (var i = 0; i < data.users.length; i++) {
                                data.users[i].selectId = i + 1;
                                data.users[i].label = data.users[i].name;
                                if (i == 0) {
                                    $scope.emailLoginModel.loginUserId = data.users[i].id;
                                    $scope.emailLoginModel.loginUserDomainId = data.users[i].domain_id;
                                }
                            }

                            $scope.emailUsers.selectOptions = data.users;
                            if (boundAccountCount > 1) {
                                // 多帐号            
                                $scope.emailLoginModel.showEmailSelect = true;
                                $scope.$apply();
                                // 重新渲染之后得到控件 设置默认值            
                                $("#emailUsers").widget().opChecked("1");
                            } else {
                                // 单帐号            
                                $scope.$apply();
                            }

                            // 查询是否需要验证码                        
                            me.loginVerify($scope);
                        } else {
                            $scope.emailUsers.selectOptions = [];
                            $scope.$apply();
                        }
                    } else {
                        // 请求返回错误            
                        if (data.message === "addrFrequencyHitMax") {
                            $scope.model.serverError = iamUtils.i18nFormat(i18n("mobileLoginModel.operationTooFrequent"), 5);
                            $scope.model.pwd = "";
                            $("#checkError").hide();
                            $("#serverError").show();
                            $scope.$apply();
                        }
                    }
                }, function () {
                    $scope.mobileLoginModel.mobileCheckLoading = false;
                    $scope.model.serverError = $scope.model.errorMsgObj["417"];
                    $("#checkError").hide();
                    $("#serverError").show();
                    $scope.$apply();
                });
            }
        };

        // 获取cbc携带过来的get参数
        if (getQueryString("userInfoType") === "mobile" && getQueryString("mobile").length > 0) {
            $scope.model.mobileLogin = true;
            $scope.mobileLoginModel.switchTypeLabel = i18n("mobileLoginModel.accountLogin");
            $scope.model.mobileLogin = true;
            // $scope.model.userNamePH = i18n("mobileLoginModel.mobilePlaceHolder");
            $scope.mobileInput.value = getQueryString("mobile");
            $scope.mobileLoginModel.countryCode = getQueryString("countryCode");
            // getCountryCode($scope);
            // 调用接口判断是否注册
            $scope.mobileLoginModel.mobileExist();
        } else {
            $scope.mobileLoginModel.initSwitchType();
        }
        
        // 下拉框定义
        $scope.mobileUsers = {
            id: "mobileUsers",
            width: "320px",
            scrollHeight: 200,
            inputFieldHeight: "38px",
            mode: "single",
            selectOptions: [],
            select: function(selectId, label) {
                $scope.mobileLoginModel.selectedUser = this.getSelectedUser(selectId, label);
                $scope.mobileLoginModel.loginUserId = $scope.mobileLoginModel.selectedUser.id;
                $scope.mobileLoginModel.loginUserDomainId = $scope.mobileLoginModel.selectedUser.domain_id;
                // 切换用户清空密码
                $scope.model.pwd = "";
                // 查询是否需要验证码
                $scope.mobileLoginVerify();
                $scope.$apply();
            },
            getSelectedUser: function(selectId, label) {
                for (var i = this.selectOptions.length - 1; i >= 0; i--) {
                    var user = this.selectOptions[i];
                    if (user.selectId == selectId && user.label == label) {
                        return user;
                    }
                }
            }
        }

        // 邮箱用户选择下拉框定义            
        $scope.emailUsers = {
            id: "emailUsers",
            width: "320px",
            scrollHeight: 200,
            inputFieldHeight: "38px",
            mode: "single",
            selectOptions: [],
            select: function (selectId, label) {
                $scope.emailLoginModel.selectedUser = this.getSelectedUser(selectId, label);
                $scope.emailLoginModel.loginUserId = $scope.emailLoginModel.selectedUser.id;
                $scope.emailLoginModel.loginUserDomainId = $scope.emailLoginModel.selectedUser.domain_id;
                // 切换用户清空密码            
                $scope.model.pwd = "";
                // 查询是否需要验证码            
                me.loginVerify($scope);
                $scope.$apply();
            },
            getSelectedUser: function (selectId, label) {
                for (var i = this.selectOptions.length - 1; i >= 0; i--) {
                    var user = this.selectOptions[i];
                    if (user.selectId == selectId && user.label == label) {
                        return user;
                    }
                }
            }
        }

        // 联合用户登录start
        $scope.idpAccountInput = {
            id: "idpAccountInputId",
            value: "",
            oldValue: "",
            error: "",
            focused: false,
            ph: i18n("idpLogin.accountPh"),
            maxLength: 255,
            domainId: "",
            style: {
                height: iamUtils.layout.loginInputFieldHeight,
            },
            change: function () {
                $scope.idpAccountInput.oldValue = '';
                $scope.idpAccountInput.error = '';
                $scope.idpSelect.selectOptions = [];
                $scope.idpSelect.disable = true;
                $scope.idpSelect.selected = {};
                $scope.idpSelect.defaultSelectId = '';
            },
            blur: function () {
                if ($scope.idpAccountInput.value === "" || $scope.idpAccountInput.value === $scope.idpAccountInput.oldValue) return;
                $scope.getIDPs($scope);
            },
        }

        // 手机号多用户下拉选择框
        $scope.idpSelect = {
            id: "idpSelect",
            disable: true,
            selectOptions: [],
            selected: {},
            defaultSelectId: '',
            width: '304px',
            scrollHeight: '',
            inputFieldHeight: '',
            ph: i18n("idpLogin.listPh"),
            select: function (selectId) {
                for (var i = 0; i < $scope.idpSelect.selectOptions.length; i++) {
                    if ($scope.idpSelect.selectOptions[i].selectId === selectId) {
                        $scope.idpSelect.selected = $scope.idpSelect.selectOptions[i];
                        break;
                    }
                }
            }
        };

        // 快捷登录按钮
        $scope.idpLoginBtn = {
            submitBtnText: i18n('idpLogin.goLogin'),
            disable: false,
            loginClick: function () {
                if (!$scope.idpAccountInput.value || $scope.idpAccountInput.error || $scope.idpSelect.disable) return;
                cookieOp.addCookie("loginType", "idp", cookieOp.DEFAULT_EXPIRES_TIME);
                if($scope.model.rememberChecked){
                    var cookieObj = {
                        domainName: $scope.idpAccountInput.value,
                        selectedIdpId: $scope.idpSelect.selected.selectId
                    }
                    cookieOp.addCookie("enterprise_idp", JSON.stringify(cookieObj), cookieOp.DEFAULT_EXPIRES_TIME);
                    cookieOp.addCookie("rememberChecked", true, cookieOp.DEFAULT_EXPIRES_TIME);
                }else{
                    cookieOp.delCookie("enterprise_idp");
                    cookieOp.delCookie("rememberChecked");
                }
                var url = `https://${window.LOGIN_CONFIG.AUTH_DOMAIN}/authui/federation/websso?domain_id=` +
                    $scope.idpAccountInput.domainId + "&idp=" + $scope.idpSelect.selected.selectId + "&protocol=" + $scope.idpSelect.selected.protocol.toLowerCase();
                var service = iamUtils.getUrlParams()['service'];
                if (service) {
                    url += '&service=' + encodeURIComponent(service);
                } 
                window.location.href = url;
            }
        };

        $scope.goAccountLogin = function () {
            $scope.model.isCompany = false;
            $scope.model.isIdpLogin = false;
        }

        $scope.goIAMLogin = function () {
            $scope.model.isCompany = true;
            $scope.model.isIdpLogin = false;
        }

        $scope.goIdpLogin = function () {
            $scope.model.isIdpLogin = true;
        }

        //通过domainName获取idp列表
        $scope.getIDPs = function ($scope, defaultSelectId) {
            iamHttpService.post({
                url: "/authui/identityProviders",
                params: {
                    domain_name: encodeURIComponent($scope.idpAccountInput.value)
                }
            }).then(function (data) {
                data = typeof data === 'object' ? data : JSON.parse(data);
                $scope.idpSelect.selectOptions = [];
                $scope.idpAccountInput.domainId = data.domain_id;
                $scope.idpAccountInput.oldValue = $scope.idpAccountInput.value;
                for (var i = 0; i < data.identity_providers.length; i++) {
                    $scope.idpSelect.selectOptions.push({
                        label: data.identity_providers[i].id,
                        selectId: data.identity_providers[i].id,
                        protocol: data.identity_providers[i].protocol,
                    });
                    if (data.identity_providers[i].id === defaultSelectId) {
                        $scope.idpSelect.defaultSelectId = data.identity_providers[i].id;
                        $scope.idpSelect.selected = $scope.idpSelect.selectOptions[$scope.idpSelect.selectOptions.length - 1];
                    }
                }
                if ($scope.idpSelect.selectOptions.length === 0) {
                    $scope.idpAccountInput.error = $scope.model.errorMsgObj['noIdps'];
                } else {
                    if (!$scope.idpSelect.selected.selectId) {
                        $scope.idpSelect.defaultSelectId = $scope.idpSelect.selectOptions[0].selectId;
                        $scope.idpSelect.selected = $scope.idpSelect.selectOptions[0];
                    }
                    $scope.idpSelect.disable = false;
                }
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            }, function (data) {
                var response = typeof data.responseText === "object" ? data.responseText : $.parseJSON(data.responseText);
                if(response.error_code === "IAM.0004")response.error_code = "noIdps";
                if(response.lock_time) response.error_code = "idpIpLock";
                $scope.idpAccountInput.error = $scope.getErrorInfo(response.error_code);
                if(response.lock_time) $scope.idpAccountInput.error = iamUtils.i18nFormat($scope.idpAccountInput.error, response.lock_time);
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            });
        }

        $scope.getErrorInfo = function (errorCode) {
            return $scope.model.errorMsgObj[errorCode] || i18n("systemException");
        }

        // 监听 $scope.model.isCompany 变量, 每次切换登录方式初始化手机登录按钮
        $scope.$watch('model.isCompany', function(newValue, oldValue) {
            if (newValue !== oldValue) {
                $scope.mobileLoginModel.initSwitchType();
            }
            if (newValue === true) {
                $scope.model.userNamePH = i18n('userNamePlaceHolder');
            }
        })
        $scope.mobileBlur = function() {
            $("#checkError").hide();
            $("#serverError").hide();
            if (!window.tinyWidget.UnifyValid.FormValid($("#loginForm"))) {
                // 检查表单中的校验模块 是否通过
                return;
            } else {
                $scope.mobileLoginModel.mobileExist();
            }
        }
        $scope.mobileChange = function() {
            $("#checkError").hide();
            $("#serverError").hide();
            $scope.mobilePasswordInput.value = "";
            $scope.mobileInput.oldValue = "";
            $scope.mobileLoginModel.showMobileErrorMsg = false;
            $scope.mobileLoginModel.showMobileSelect = false;
            $scope.$apply();
        }
        $scope.mobileLoginVerify = function() {
            iamHttpService.post({
                url: "/authui/login/verify",
                params: {
                    userName:  $scope.mobileLoginModel.loginUserId,
                    userType: "id",
                    accountName: $scope.mobileLoginModel.loginUserDomainId
                }
            }).then(function (data) {
                $scope.model.isNeedVerifyCode = data.needVerify;
                $scope.$apply();
            }, function() {
                $scope.model.isNeedVerifyCode = true;
                $scope.$apply();
            });
        }
        /*** END 手机号登录需求相关代码 ***/

        function getRegistUrl() {
            var service_url = iamUtils.getUrlParams()['service'] ;
            var registUrl = $scope.ipIsInternational? iamUtils.CONFIG.cbcRegUrlIntl : iamUtils.CONFIG.cbcRegUrl;
            registUrl += "&hwid=login";
            registUrl += service_url ? "&service=" + encodeURIComponent(service_url) : "";
            return registUrl;
        }

        function getFpwdUrl() {
            return "/authui/login.html?locale=" + window.language + "&UserType=" + ($scope.model.isCompany ? "e" : "p") + LoginController.getServiceFromUrl() + "#/fpwd";
        }

        function createAdvScript() {
            var loginAdv = document.getElementById("loginAdv");
            
            // if( $scope.ipIsInternational && loginAdv){
            //     $("#loginAdv").empty();
            //     $("#loginAdv").append("<img id='loginlogo' style='margin-left:40px' />");
            //     $("#loginlogo").attr("src",getLoginLogo());
            //     return;
            // }
            
            if(iamUtils.isShowByStyleOfSite() && loginAdv)
            {
                $("#loginAdv").empty();
                $("#loginAdv").append("<img id='loginlogo'  />");
                $("#loginlogo").attr("src",getLogoOfRussia());
                return;
            }

            var oScript = document.createElement("script");
            oScript.type = "text/javascript";
            var getAdApi = window.replaceDomain("https://portal.huaweicloud.com/rest/cbc/portalapppublishservice/v1/ad/disp");
            var pos = "";
            var comp = "";
            if (loginAdv) {
                if ($scope.ipIsInternational) {
                    // 国际IP
                    switch (window.language) {
                        case "zh-cn":
                            pos = "www.huaweicloud.com/ad/login_board_en-zh.html";
                            comp = "pep-ad-img_1620800848076";
                            break;
                        case "en-us":
                            pos = "www.huaweicloud.com/ad/login_board_en-us.html";
                            comp = "pep-ad-img_1620800987830";
                            break;
                        default:
                            pos = "www.huaweicloud.com/ad/login_board_en-us.html";
                            comp = "pep-ad-img_1620800987830";
                            break;
                    }
                } else {
                    // 国内IP
                    switch (window.language) {
                        case "zh-cn":
                            pos = "www.huaweicloud.com/ad/login_board.html";
                            comp = "pep-ad-img_1619667657367";
                            break;
                        case "en-us":
                            pos = "www.huaweicloud.com/ad/login_board_ch-us.html";
                            comp = "pep-ad-img_1620800651862";
                            break;
                        default:
                            pos = "www.huaweicloud.com/ad/login_board_ch-us.html";
                            comp = "pep-ad-img_1620800651862";
                            break;
                    }
                }
                oScript.src = getAdApi + "?pos=" + pos + "&comp=" + comp + "&containerId=loginAdv&st=" + Math.random();
                loginAdv.appendChild(oScript);
            }
        }

        function getEchannelUrl() {
            var defaultUrl = "/authui/saml/login?xAccountType=eChannel";
            if($scope.ipIsInternational){
                return  iamUtils.CONFIG.hkUserCenterUrl ? "/authui/saml/login?xAccountType=eChannel&service=" + encodeURIComponent(iamUtils.CONFIG.hkUserCenterUrl + "/#/userindex/allview") :defaultUrl;
                
            }else{
                return  iamUtils.CONFIG.userCenterUrl ? "/authui/saml/login?xAccountType=eChannel&service=" + encodeURIComponent(iamUtils.CONFIG.userCenterUrl + "/#/userindex/allview") : defaultUrl;
            }
        }

        function getVmallServiceFromUrl() {
            var service = iamUtils.getUrlParams()["service"]
            var loginjsp = iamUtils.CONFIG.vmallCASUrl + "/oauth2/portal/login.jsp";
            var vmall = window.location.protocol + "//" + window.location.host + "/rest/authui/vmall/otherlogin";
            var homepage_intl= window.replaceDomain($scope.ipIsInternational? "intl.huaweicloud.com" : "www.huaweicloud.com");;
            if(service !== undefined)
            {
                vmall = vmall + "?service=" + encodeURIComponent(service);
            }else{
                vmall = vmall + "?service=" + encodeURIComponent("http://"+homepage_intl);
            }

            return "&service=" + encodeURIComponent(vmall) + "&loginUrl=" + encodeURIComponent(loginjsp);
        }

        function getVmallUrl() {
            return iamUtils.CONFIG.vmallCASUrl + "/CAS/remoteLogin?lang=" + window.language + "&validated=true&submit=true" + getVmallServiceFromUrl() + "&loginChannel=53000000&reqClientType=53";
        }

        // 扫码登录需求相关
        $scope.QRLoginModel = {
            hasQRLogin: iamUtils.CONFIG.hasQrlogin === "true" ? true : false, 
            QRLoginType: false,
            QRLoginTitle: i18n("QRLogin.title1"),
            showTip: false,
            langIsCh: window.language === "zh-cn", //暂时只有中文页面显示二维码登录
            countDownTipPre: i18n("QRLogin.countDownTipPre"),
            remainingTime: window.language === "zh-cn" ? iamUtils.i18nFormat(i18n("QRLogin.remainingTime"), QRCODE_VALID_TIME) : "",
            countDownTipSuffix: i18n("QRLogin.countDownTipSuffix"),
            countDownInterval: null,
            showTipTimer: null,
            pollingInterval: null,
            QRCodeInvalid: false,
            QRCodeStatus: "new", //new, authorizing, refused, authorized
            downloadUrl: getDownloadUrl(),
            clientKey: "", //二维码标识
            failTipPre: '',
            failTipLink: '',
            failTipSuffix: '',
            qrLoginMsgObj: {
                'refused': {
                    pre: i18n('QRLogin.loginFailTipPre'),
                    link: i18n('QRLogin.refresh'),
                    suffix: i18n('QRLogin.loginFailTipSuffix'),
                },
                'expired': {
                    pre: i18n('QRLogin.loginFailTipPre'),
                    link: i18n('QRLogin.refresh'),
                    suffix: i18n('QRLogin.loginFailTipSuffix'),
                },
                [ACL_DENY_CODE]: {
                    pre:  i18n('clientIpInvalid') + i18n('QRLogin.aclTipPre'),
                    link: i18n('QRLogin.aclTipLink'),
                    suffix: i18n('QRLogin.aclTipSuffix'),
                }
            },
            QRLoginTypeSwitch: function(){
                $scope.QRLoginModel.QRLoginType = !$scope.QRLoginModel.QRLoginType;
                if($scope.QRLoginModel.QRLoginType){
                    //切换到扫码登录
                    send2CloudBISafe(iamUtils.pages.login, "click_QRLogin");
                    QRCodeInit();
                } else {
                    //切换到帐号登录
                    $interval.cancel($scope.QRLoginModel.pollingInterval);
                }
                showLoginTypeTip();
            },
            refreshQRCode: function(){
                QRCodeInit();
            }
        }

        // 获取登录凭证并生成二维码
        function QRCodeInit(){
            $scope.QRLoginModel.QRLoginTitle = i18n("QRLogin.title1");
            $scope.QRLoginModel.QRCodeStatus = "new";
            $scope.QRLoginModel.QRCodeInvalid = false;
            iamHttpService.get({
                url: "/authui/qrcode",
                cache: false,
                params: {}
            }).then(function (data) {
                data = typeof data === "object" ? data : $.parseJSON(data);
                $scope.QRLoginModel.clientKey = data.client_key;
                $timeout(function () {
                    var loginQRCodeDiv = document.querySelector('#loginQRCodeDiv');
                    loginQRCodeDiv.innerHTML = "";
                    QRCode.toCanvas(loginQRCodeDiv, 
                           data.qrcode_content, {
                               margin: 0,
                               width: 160
                           }
                    );
                }, 0);
                countDown();
                pollingCodeStatus();
            }, function () {
                // 异常情况
                $scope.QRLoginModel.QRCodeInvalid = true;
                $scope.$apply();
            })   
        } 

        // 显示帐号登录tip，并在5秒后隐藏
        function showLoginTypeTip() {
            $timeout.cancel($scope.QRLoginModel.showTipTimer);
            $scope.QRLoginModel.showTip = true;
            $scope.QRLoginModel.showTipTimer = $timeout(function () {
                $scope.QRLoginModel.showTip = false;
            }, 5000);
        }

        // 二维码失效时间倒计时
        function countDown() {
            var count = 0;
            $scope.QRLoginModel.remainingTime = iamUtils.i18nFormat(i18n("QRLogin.remainingTime"), QRCODE_VALID_TIME - count);
            $interval.cancel($scope.QRLoginModel.countDownInterval);
            $scope.QRLoginModel.countDownInterval = $interval(function () {
                count++;
                if (count < QRCODE_VALID_TIME) {
                    $scope.QRLoginModel.remainingTime = iamUtils.i18nFormat(i18n("QRLogin.remainingTime"), QRCODE_VALID_TIME - count);
                } else {
                    $scope.QRLoginModel.QRCodeInvalid = true;
                    $interval.cancel($scope.QRLoginModel.countDownInterval);
                    $interval.cancel($scope.QRLoginModel.pollingInterval);
                }
            }, 1000);
        }

        // 轮询登录状态 
        function pollingCodeStatus() {
            var params = {};
            params.client_key = $scope.QRLoginModel.clientKey;
            var service = iamUtils.getUrlParams()["service"];
            if (service) {
                params.service = service;
            }
            $interval.cancel($scope.QRLoginModel.pollingInterval);
            $scope.QRLoginModel.pollingInterval = $interval(function () {
                iamHttpService.get({
                    url: "/authui/qrcode/status",
                    cache: false,
                    params: params,
                }).then(function (data) {
                    data = typeof data === "object" ? data : $.parseJSON(data);
                    if (data.error_code && data.error_code == "427") {
                        location.reload();
                    } else if ($scope.QRLoginModel.qrLoginMsgObj[data.status] || $scope.QRLoginModel.qrLoginMsgObj[data.error_code]) {
                        $scope.QRLoginModel.QRCodeStatus = "refused";
                        $scope.QRLoginModel.QRLoginTitle = i18n("QRLogin.title2");
                        var errorMsg = $scope.QRLoginModel.qrLoginMsgObj[data.status] || $scope.QRLoginModel.qrLoginMsgObj[data.error_code];
                        $scope.QRLoginModel.failTipPre = errorMsg.pre,
                            $scope.QRLoginModel.failTipLink = errorMsg.link,
                            $scope.QRLoginModel.failTipSuffix = errorMsg.suffix,
                            $interval.cancel($scope.QRLoginModel.pollingInterval);
                    } else if (data.status == "authorizing") {
                        send2CloudBISafe(iamUtils.pages.login, "click_scanQRCode");
                        $scope.QRLoginModel.QRCodeStatus = "authorizing";
                        $scope.QRLoginModel.QRLoginTitle = i18n("QRLogin.title2");
                        $interval.cancel($scope.QRLoginModel.countDownInterval);
                    } else if (data.status == "authorized") {
                        window.location.href = data.redirect_url;
                        $interval.cancel($scope.QRLoginModel.pollingInterval);
                    }
                }, function () { });
            }, 3000);
        }

        // 获取下载APP链接
        function getDownloadUrl(){
            return window.replaceDomain("https://www.huaweicloud.com/mobile_app/hwapp.html");
        }

        showLoginTypeTip();
        // 扫码登录END

        initFromQuickLogin($scope);

        loadRiskJs($scope.cbcRiskcheckAddress);
    }

    $.extend(CustomerLoginController.prototype, LoginController.prototype);

    CustomerLoginController.prototype.countryCodeProcess = function ($scope, userType){};
    
    //获取香港国际站的页面大logo
    function getLoginLogo(){
        if (window.language === "zh-cn") {
            return "/authui/public/custom/images/login_logo_zh_cn.png";
        } else if (window.language === "en-us") {
            return "/authui/public/custom/images/login_logo_en_us.png";
        } else if (window.language === "es-us") {
            return "/authui/public/custom/images/login_logo_es_us.png";
        } else if (window.language === "pt-br") {
            return "/authui/public/custom/images/login_logo_pt_br.png";
        } else {
            return "/authui/public/custom/images/login_logo_en_us.png";
        }
    }

    // Russia 
    function getLogoOfRussia() {
    	return "/authui/public/custom/images/loginimg_en-us.png"
    }
    
    
    function getHwPortalUrl() {
        var service = iamUtils.getUrlParams()['service'];
        if (service) {
          return '/authui/saml/login?xAccountType=hwportal&service=' + encodeURIComponent(service);
        } else {
          return '/authui/saml/login?xAccountType=hwportal';
        }
    }

    function getHwDeveloperUrl() {
        var service = iamUtils.getUrlParams()["service"]
        if (service) {
            return "/authui/saml/login?xAccountType=hwdeveloper&service=" + encodeURIComponent(service);
        } else {
            return "/authui/saml/login?xAccountType=hwdeveloper";
        }
    }
    
    function getUniportalUrl() {
        var service = iamUtils.getUrlParams()["service"]
        if (service) {
            return "/authui/saml/login?xAccountType=uniportal&service=" + encodeURIComponent(service);
        }else {
            return "/authui/saml/login?xAccountType=uniportal";
        }
    }

    // RR2020021101004
    function getWeLinkUrl() {
        var url = "/authui/oAuthLogin?idp=welink";
        var service = iamUtils.getUrlParams()["service"];
        if (service) {
            // 如果url中存在 service 则使用 url中的 service
            url = url + "&service=" + encodeURIComponent(service);
        } else {
            // 否则使用 welink提供的配置项
            url = url + "&service=" + encodeURIComponent("https://www.huaweicloud.com/product/welink.html");
        }
        
        if ("https://welink.huaweicloud.com/wecode/error.html" !== "") {
            url = url + "&errorPage=" + encodeURIComponent("https://welink.huaweicloud.com/wecode/error.html");
        }

        url = window.replaceDomain(url);
        
        return url;
    }

    // 获取get参数
    function getQueryString(param) {
        var reg = "(^|[&|?])" + param + "=([^&|#]*)(&|#|$)";
        var r = window.location.href.substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    }

    function initFromQuickLogin($scope) {
        if ($scope.model.fromQuickLogin) {
            $scope.model.moreLinkIsShow = true;
        }
    }

    function getQuickLoginUrl() {
        var url = "/authui/login.html";
        var service = iamUtils.getUrlParams()["service"];
        if (service) {
            // 如果url中存在 service 则使用 url中的 service
            url = url + "?service=" + encodeURIComponent(service);
        }
        if (iamUtils.CONFIG.hasHwid === "true") {
            return url + "#/login";
        } else {
            return url + "#/hwIDLogin";
        }
        
    }

    //加载cbc风控组件
    function loadRiskJs(url) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        document.getElementsByTagName('head')[0].appendChild(script);
    }

    CustomerLoginController = ["$scope", "$timeout", "securityPolicy", "$state", "$sce",  "$interval", CustomerLoginController];
    var loginModule = angular.module('authui.config');
    loginModule.controller('authui.login2.ctrl', CustomerLoginController);
    return loginModule;
}),define(["authui/login2/controllers/login2Controller"], function () {
});



// WEBPACK FOOTER //
// ./public/hws/js/login2/controllers/login2Controller.js